export async function login(email: string, password: string) {
  return fetch('/api/Account/login', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({email, password}),
  })
    .then(response => response.json())
    .catch(error => {
      // Handle any errors during the request
      console.error('Error:', error);
    });
}
